import { ListStore } from '@list-store';
import { useCallback, useEffect, useState } from 'react';

export type ResultSelectionStore = {
    selectedItems: {
        [id: string]: true;
    };
    anySelected: boolean;
    allSelected: boolean;
    selectAllOnPage: () => void;
    unselectAllOnPage: () => void;
    toggleSelected: (id: number) => void;
    selectAll: () => void;
    unselectAll: () => void;
};

export function useObservableSearchResultSelectionStore(
    items: { id: number }[],
    totalCount: number
): ResultSelectionStore {
    const [listStore] = useState(new ListStore());
    useEffect(() => {
        listStore.setItems(items);
    }, [listStore, items]);

    const [allSelectedAcrossPages, setAllSelectedAcrossPages] = useState<boolean>(false);

    const anySelected = Object.keys(listStore.selectedItems).length > 0;
    const allSelectedOnPageAndAllResultsOnPage =
        totalCount > 0 && Object.keys(listStore.selectedItems).length === totalCount;
    const allSelected = allSelectedOnPageAndAllResultsOnPage || allSelectedAcrossPages;

    const toggleSelected = useCallback(
        (id) => {
            listStore.toggleItemSelection(id);
            setAllSelectedAcrossPages(false);
        },
        [listStore]
    );

    const selectAllOnPage = useCallback(() => {
        listStore.setSelectedItems(items.map((item) => item.id));
    }, [items, listStore]);
    const unselectAllOnPage = useCallback(() => {
        listStore.setSelectedItems([]);
    }, [listStore]);

    const selectAll = useCallback(() => {
        selectAllOnPage();
        setAllSelectedAcrossPages(true);
    }, [selectAllOnPage, setAllSelectedAcrossPages]);
    const unselectAll = useCallback(() => {
        unselectAllOnPage();
        setAllSelectedAcrossPages(false);
    }, [unselectAllOnPage]);

    return {
        selectedItems: listStore.selectedItems,
        anySelected,
        allSelected,
        selectAllOnPage,
        unselectAllOnPage,
        toggleSelected,
        selectAll,
        unselectAll,
    };
}
